// Hooks
import { useLocation } from 'react-router-dom';

// Utils
import { parseQueryStringToObj } from '@shopee/url-util';
import {
  isWebBridgeSupported,
  getPlatformType,
  PlatformType,
} from '@shopee/web-bridge-sdk';

// Styles
import styles from './style.scss';

// Types
import type {
  WithUserWebViewProps,
  Props as WithUserWebViewConfig,
} from './types';
export type { WithUserWebViewProps, WithUserWebViewConfig };

// HOC
export { withUserWebView } from './withWebView';

// Constants
export { PAGE_EXIT_STATE, AuthenticationSource, AuthMethod } from './constants';

// Get class name to handle the safe area in iOS
export function getSafeAreaClassName(): string {
  return isWebBridgeSupported() && getPlatformType() === PlatformType.iOS
    ? (styles.containerIOSApp as string)
    : '';
}

// Ultility hook to get whether should show the back button in navbar or not
export const useShouldHideBack = (): boolean => {
  const location = useLocation();

  return parseQueryStringToObj(location.search).should_hide_back === 'true';
};
